export default "__VITE_ASSET__44ce1517__"